import React from 'react';
import { getDomainConfig, CONTACT_INFO } from '../config';
import { Link } from 'react-router-dom';
import './AboutPage.css';

function AboutPage() {
  const config = getDomainConfig();
  const hostname = window.location.hostname.replace('www.', '');
  const displayEmail = `info@${hostname}`;

  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>About {config.name}</h1>
        <p className="subtitle">{config.tagline}</p>
      </div>

      <div className="about-content">
        <section className="about-section">
          <h2>Who We Are</h2>
          <p>
            {config.name} is a B2B product sourcing platform operated by {CONTACT_INFO.businessName},
            based in {CONTACT_INFO.city}, {CONTACT_INFO.state}. We specialize in
            {' '}{config.tagline.toLowerCase()}, connecting business buyers with verified industrial
            suppliers and manufacturers across North America.
          </p>
          <p>
            Our platform provides detailed product information, specifications, and pricing from a
            curated network of suppliers, making it easy for businesses to find and source the
            products they need.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            To simplify B2B procurement by providing a comprehensive, easy-to-navigate platform
            that connects buyers with the products and suppliers they need. We believe that finding
            the right industrial products should be straightforward and transparent.
          </p>
        </section>

        <section className="about-section">
          <h2>How It Works</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>1. Browse Products</h3>
              <p>Search our catalog of products with detailed specifications and pricing from verified suppliers</p>
            </div>
            <div className="feature">
              <h3>2. Request a Quote</h3>
              <p>Submit a quote request for the products you need and we'll connect you with the right supplier</p>
            </div>
            <div className="feature">
              <h3>3. Get Connected</h3>
              <p>Our team facilitates the connection between you and the supplier for pricing and ordering</p>
            </div>
            <div className="feature">
              <h3>4. Receive Your Order</h3>
              <p>Products are shipped directly from the supplier to your location with tracking provided</p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Why Choose {config.name}?</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>Extensive Catalog</h3>
              <p>Access to hundreds of thousands of products across multiple categories from trusted manufacturers</p>
            </div>
            <div className="feature">
              <h3>Verified Suppliers</h3>
              <p>All suppliers in our network are carefully vetted to ensure product quality and reliability</p>
            </div>
            <div className="feature">
              <h3>Transparent Pricing</h3>
              <p>View pricing upfront and request competitive quotes for volume orders</p>
            </div>
            <div className="feature">
              <h3>Dedicated Support</h3>
              <p>Our team is available to help you find the right products and connect with suppliers</p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Contact Us</h2>
          <p>
            We're here to help with your sourcing needs. Reach out to our team:
          </p>
          <p><strong>{CONTACT_INFO.businessName}</strong></p>
          <p>Email: {displayEmail}</p>
          <p>Phone: {CONTACT_INFO.phone}</p>
          <p>Address: {CONTACT_INFO.address}, {CONTACT_INFO.city}, {CONTACT_INFO.state} {CONTACT_INFO.zip}</p>
          <p>Business Hours: Monday - Friday, 8:00 AM - 6:00 PM EST</p>
          <p style={{ marginTop: '1.5rem' }}>
            <Link to="/contact" style={{ color: 'var(--primary-color)', fontWeight: '600' }}>
              Send us a message &rarr;
            </Link>
          </p>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;
